var _circle, _path, _path2, _circle2, _path3, _path4, _circle3, _path5, _path6, _circle4, _path7, _path8, _circle5, _path9, _path10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoinsFive = function SvgCoinsFive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 40,
    viewBox: "0 0 128 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 20,
    r: 18.5,
    fill: "#5656FC",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.043 14.5305L102.048 21.6291V25.5109H104.353V21.6291L108.359 14.5305H105.758L103.254 19.2593H103.147L100.643 14.5305H98.043Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.583 17.6884H117.808C117.776 15.7315 116.168 14.3804 113.723 14.3804C111.315 14.3804 109.551 15.71 109.562 17.7045C109.557 19.3237 110.699 20.2512 112.554 20.6962L113.75 20.9965C114.945 21.286 115.61 21.6291 115.615 22.369C115.61 23.1732 114.849 23.7201 113.669 23.7201C112.463 23.7201 111.594 23.1625 111.519 22.0634H109.273C109.332 24.4386 111.031 25.6663 113.696 25.6663C116.377 25.6663 117.953 24.3849 117.958 22.3744C117.953 20.5461 116.575 19.5757 114.666 19.1468L113.68 18.9108C112.725 18.691 111.927 18.3372 111.943 17.549C111.943 16.8413 112.57 16.3212 113.707 16.3212C114.816 16.3212 115.497 16.8252 115.583 17.6884Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 20,
    r: 18.5,
    fill: "#5656FC",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.043 14.5305L80.048 21.6291V25.5109H82.3535V21.6291L86.3585 14.5305H83.7582L81.2544 19.2593H81.1471L78.6433 14.5305H76.043Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5831 17.6884H95.8082C95.776 15.7315 94.1675 14.3804 91.7227 14.3804C89.3154 14.3804 87.5514 15.71 87.5622 17.7045C87.5568 19.3237 88.6988 20.2512 90.5539 20.6962L91.7495 20.9965C92.9451 21.286 93.6099 21.6291 93.6153 22.369C93.6099 23.1732 92.8486 23.7201 91.6691 23.7201C90.4627 23.7201 89.5942 23.1625 89.5191 22.0634H87.2726C87.3316 24.4386 89.0312 25.6663 91.6959 25.6663C94.3766 25.6663 95.9529 24.3849 95.9583 22.3744C95.9529 20.5461 94.575 19.5757 92.6663 19.1468L91.6798 18.9108C90.7255 18.691 89.9266 18.3372 89.9427 17.549C89.9427 16.8413 90.57 16.3212 91.7066 16.3212C92.8164 16.3212 93.4974 16.8252 93.5831 17.6884Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 20,
    r: 18.5,
    fill: "#5656FC",
    stroke: "white",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.043 14.5305L58.048 21.6291V25.5109H60.3535V21.6291L64.3585 14.5305H61.7582L59.2544 19.2593H59.1471L56.6433 14.5305H54.043Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5831 17.6884H73.8082C73.776 15.7315 72.1675 14.3804 69.7227 14.3804C67.3154 14.3804 65.5514 15.71 65.5622 17.7045C65.5568 19.3237 66.6988 20.2512 68.5539 20.6962L69.7495 20.9965C70.9451 21.286 71.6099 21.6291 71.6153 22.369C71.6099 23.1732 70.8486 23.7201 69.6691 23.7201C68.4627 23.7201 67.5942 23.1625 67.5191 22.0634H65.2726C65.3316 24.4386 67.0312 25.6663 69.6959 25.6663C72.3766 25.6663 73.9529 24.3849 73.9583 22.3744C73.9529 20.5461 72.575 19.5757 70.6663 19.1468L69.6798 18.9108C68.7255 18.691 67.9266 18.3372 67.9427 17.549C67.9427 16.8413 68.57 16.3212 69.7066 16.3212C70.8164 16.3212 71.4974 16.8252 71.5831 17.6884Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 20,
    r: 18.5,
    fill: "#5656FC",
    stroke: "white",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.043 14.5305L36.048 21.6291V25.5109H38.3535V21.6291L42.3585 14.5305H39.7582L37.2544 19.2593H37.1471L34.6433 14.5305H32.043Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5831 17.6884H51.8082C51.776 15.7315 50.1675 14.3804 47.7227 14.3804C45.3154 14.3804 43.5514 15.71 43.5622 17.7045C43.5568 19.3237 44.6988 20.2512 46.5539 20.6962L47.7495 20.9965C48.9451 21.286 49.6099 21.6291 49.6153 22.369C49.6099 23.1732 48.8486 23.7201 47.6691 23.7201C46.4627 23.7201 45.5942 23.1625 45.5191 22.0634H43.2726C43.3316 24.4386 45.0312 25.6663 47.6959 25.6663C50.3766 25.6663 51.9529 24.3849 51.9583 22.3744C51.9529 20.5461 50.575 19.5757 48.6663 19.1468L47.6798 18.9108C46.7255 18.691 45.9266 18.3372 45.9427 17.549C45.9427 16.8413 46.57 16.3212 47.7066 16.3212C48.8164 16.3212 49.4974 16.8252 49.5831 17.6884Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5,
    fill: "#5656FC",
    stroke: "white",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.043 14.5305L14.048 21.6291V25.5109H16.3535V21.6291L20.3585 14.5305H17.7582L15.2544 19.2593H15.1471L12.6433 14.5305H10.043Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5831 17.6884H29.8082C29.776 15.7315 28.1675 14.3804 25.7227 14.3804C23.3154 14.3804 21.5514 15.71 21.5622 17.7045C21.5568 19.3237 22.6988 20.2512 24.5539 20.6962L25.7495 20.9965C26.9451 21.286 27.6099 21.6291 27.6153 22.369C27.6099 23.1732 26.8486 23.7201 25.6691 23.7201C24.4627 23.7201 23.5942 23.1625 23.5191 22.0634H21.2726C21.3316 24.4386 23.0312 25.6663 25.6959 25.6663C28.3766 25.6663 29.9529 24.3849 29.9583 22.3744C29.9529 20.5461 28.575 19.5757 26.6663 19.1468L25.6798 18.9108C24.7255 18.691 23.9266 18.3372 23.9427 17.549C23.9427 16.8413 24.57 16.3212 25.7066 16.3212C26.8164 16.3212 27.4974 16.8252 27.5831 17.6884Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinsFive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coinsFive.ecb81c68.svg";
export { ForwardRef as ReactComponent };